import MultiSelect from '../controls/MultiSelect';
import { Controller } from 'react-hook-form';



function ControlledMultiSelect({control, name, items, label, errors, className, maxHeight, selectAll, required, infoText}) {
   const useClasses = className ? className : "mt-8 mb-16";

   return (
	   
	<Controller
       control={control}
       name={name}
       render={({ field }) => <MultiSelect 
                              {...field}
                              required={required}
                              infoText={infoText}
                              items={items}
                              className={useClasses}
                              id={name} 
                              label={label}
                              errors={errors}
                              selectAll={selectAll}
                              maxHeight={maxHeight}
                            />}
    />
   );
}

export default ControlledMultiSelect;
